import {
  setStore,
  getStore
} from '@/utils/store'
const common = {

  state: {
    isFullScren: false,
    theme: getStore({ name: 'theme' }) || { navbarColor: 'success', sidebarColor: 'success', layout: [] },
    platformNameLogo: ''
  },
  actions: {
  },
  mutations: {
    SET_FULLSCREN: (state, action) => {
      state.isFullScren = !state.isFullScren
    },
    SET_THEME: (state, theme) => {
      state.theme = theme
      setStore({
        name: 'theme',
        content: state.theme
      })
    }
  }
}
export default common



// WEBPACK FOOTER //
// ./src/store/modules/common.js